import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export const Layout = ({ children, title, subtitle, avatar, showBack = false }) => {
  const location = useLocation();
  
  return (
    <div className="telegram-app">
      <div className="tg-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {showBack && (
            <button className="tg-btn" style={{ width: 'auto', padding: '4px 12px', background: 'transparent', color: 'var(--tg-blue)' }} onClick={() => window.history.back()}>←</button>
          )}
          <div className="tg-avatar">{avatar || '🚗'}</div>
          <div>
            <div className="tg-header-title">{title || 'OJESI'}</div>
            <div className="tg-header-sub">{subtitle || 'ojesi.cafee.id'}</div>
          </div>
        </div>
      </div>

      <div style={{ paddingBottom: '70px' }}>{children}</div>

      <div className="tg-bottom-nav">
        <Link to="/" className={`tg-nav-item ${location.pathname === '/' ? 'active' : ''}`}>
          <span className="nav-icon">🏠</span>Home
        </Link>
        <Link to="/order" className={`tg-nav-item ${location.pathname.includes('/order') ? 'active' : ''}`}>
          <span className="nav-icon">📦</span>Order
        </Link>
        <Link to="/chat" className={`tg-nav-item ${location.pathname.includes('/chat') ? 'active' : ''}`}>
          <span className="nav-icon">💬</span>Chat
        </Link>
        <Link to="/profile" className={`tg-nav-item ${location.pathname.includes('/profile') ? 'active' : ''}`}>
          <span className="nav-icon">👤</span>Profile
        </Link>
      </div>
    </div>
  );
};
